import { Grid } from '@material-ui/core';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

import AppBar from 'Elements/Theme/AppBar/AppBar';
import Logo from 'Elements/Theme/Logo/Logo';

import MainMenu, { MenuContainer } from './MainMenu';

const Container = styled.div`
  display: flex;
  height: 100vh;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const MainContent = styled.main`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  display: flex;
`;

const MenuFooter = styled(MenuContainer)`
  margin-top: auto;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: block;
  }
`;

const MenuLogo = styled(Logo)`
  opacity: 0.2;
  transform: scale(0.65);
  margin: -10px;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
`;

const Version = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FooterBottom = styled.div`
  margin: 10px 10px 0;
  @media (max-width: 768px) {
    display: none;
  }
`;

type Props = {
  children: ReactNode;
};

export default function AppShell({ children }: Props) {
  return (
    <Container>
      <AppBar>
        <MainMenu />
        <MenuFooter>
          <FooterBottom>
            <Grid container justify="space-between" direction="row">
              <Grid item>
                <MenuLogo />
              </Grid>

              <Grid item>
                <Version></Version>
              </Grid>
            </Grid>
          </FooterBottom>
        </MenuFooter>
      </AppBar>
      <MainContent>{children}</MainContent>
    </Container>
  );
}
